define('services/bookingService',['require','utils','moment'],function(require) {
    'use strict';
    var utils = require('utils');
    var moment = require('moment');
    return {
        /**
         * Converts a planning data object to a querystring
         * Note that only stuff needed for booking is included
         * Note that manual bookings can get big, but manual bookings are done in modern browsers, so should be good. Normal bookings don't need as much data.
         * TODO: consider creating server-side PlanningDataTiny class with automapper to PlanningData that does a lookup for hotel info based on hotelid...
         * TODO: consider using $.param if qs consistently not too long...maybe unset stuff that we don't need and then param it?
         * @param {PlanningData} data 
         * @returns {string} 
         */
        serializePlanning: function(data) {
            if (data == null) {
                return '';
            }
            var tiny = {};
            var dest = data.DestinationInfo;
            if (dest != null) {
                tiny.d = dest.DestinationSourceID;
                tiny.dhc = dest.HotelCode;
                tiny.hca = dest.HotelCategory;
                tiny.dcc = dest.ChainCode;
                tiny.rk = dest.RateKey;
                tiny.dtc = dest.RoomTypeCode;
                tiny.dr = dest.RoomName;
                tiny.drd = dest.RoomDescription;
                tiny.dc = dest.RoomCorporateDisc;
                tiny.drc = dest.RoomCount;
                tiny.dt = dest.DestinationTypeID;
                tiny.dl = dest.LookupSource;
                tiny.drce = dest.RoomCode;
                var rate = dest.Rate;
                if (rate != null) {
                    tiny.rp = rate.RatePlanCode;
                    tiny.rr = rate.RoomRateTotal;
                    tiny.lrr = rate.LoyaltyRoomRateTotal;
                    tiny.lrt = rate.LoyaltyHotelTaxFeeTotal;
                    tiny.lrte = rate.LoyaltyHotelExcludedTaxTotal;
                    tiny.rt = rate.HotelTaxFeeTotal;
                    tiny.rf = rate.HotelFeeTotal;
                    tiny.ret = rate.HotelExcludedTax;
                    tiny.rrf = rate.RecoveryFee;
                }
                var region = dest.VRegion;
                if (region != null) {
                    tiny.rn = region.RegionName;
                    tiny.ri = region.RegionID;
                }
            }
            var manual = data.ManualBooking;
            if (manual != null) {
                tiny.mc = manual.Comments;
                tiny.mcf = manual.ConfirmationNumber;
                tiny.mcp = manual.CancellationPolicy;
                tiny.mrd = manual.RoomDescription;

                // Hotelbeds fields
                tiny.mvn = manual.VatNumber;
                tiny.msn = manual.SupplierName;
            }
            var travelers = data.TravelerInfo;
            if (travelers != null) {
                tiny.ta = travelers.AdultCount;
                tiny.tc = travelers.ChildAges;
                tiny.tcb = travelers.CoMemberBook;
                tiny.tcab = travelers.CoMemberAltName;
            }
            var timeline = data.Timeline;
            if (timeline != null) {
                tiny.tf = utils.formatDate(timeline.FromDate);
                tiny.tt = utils.formatDate(timeline.ToDate);
            }
            var provider = data.Provider;
            if (provider != null) {
                tiny.prov = provider;
            }
            var serialized = utils.serializeQs(tiny);
            return serialized;
        },

        /**
         * Converts a serialized planning data structure back to the full server-side-friendly planning data
         * Note we only set manual if any manual props aren't null
         * Note we set chaincode and roomtypecode to uppercase since TP is case-sensitive and copying/pasting links sometimes makes everything lowercase
         * @param {string} data 
         * @returns {PlanningData} 
         */
        deserializePlanning: function (data) {
            if (utils.isNullOrWhiteSpace(data)) {
                return null;
            }
            var tiny = utils.deserializeQs(data);
            var dest = {
                DestinationSourceID: tiny.d,
                HotelCode: tiny.dhc,
                HotelCategory: tiny.hca,
                ChainCode: tiny.dcc != null ? tiny.dcc.toUpperCase() : '',
                RateKey: tiny.rk,
                RoomTypeCode: tiny.dtc != null ? new String(tiny.dtc).toUpperCase() : '',
                RoomName: tiny.dr,
                RoomDescription: tiny.drd,
                RoomCode: tiny.drce,
                RoomCorporateDisc: tiny.dc,
                RoomCount: tiny.drc,
                DestinationTypeID: tiny.dt,
                LookupSource: tiny.dl,
                Rate: {
                    RatePlanCode: tiny.rp,
                    RoomRateTotal: tiny.rr,
                    HotelTaxFeeTotal: tiny.rt,
                    HotelFeeTotal: tiny.rf,
                    HotelExcludedTax: tiny.ret,
                    RecoveryFee: tiny.rrf,
                    LoyaltyRoomRateTotal: tiny.lrr,
                    LoyaltyHotelTaxFeeTotal: tiny.lrt,
                    LoyaltyHotelExcludedTaxTotal: tiny.lrte,
                },
                VRegion: {
                    RegionName: tiny.rn,
                    RegionID: tiny.ri
                },
            };
            var manual = tiny.mc != null || tiny.mcf != null || tiny.mcp != null || 
                            tiny.mrd != null || tiny.mvn != null || tiny.msn != null ? {
                Comments: tiny.mc,
                ConfirmationNumber: tiny.mcf,
                CancellationPolicy: tiny.mcp,
                RoomDescription: tiny.mrd,
                VatNumber: tiny.mvn,
                SupplierName: tiny.msn
            } : null;
            var travelers = {
                AdultCount: tiny.ta,
                ChildAges: tiny.tc != null ? tiny.tc.toString().split(',') : [], //note that deserialize skips empty arrays, so set to empty so server doesn't get pissed
                CoMemberBook: tiny.tcb,
                CoMemberAltName: tiny.tcab
            };
            var timeline = {
                FromDate: moment(tiny.tf, 'MM/DD/YYYY'),
                ToDate: moment(tiny.tt, 'MM/DD/YYYY')
            };
            var provider = tiny.prov;
            return {
                DestinationInfo: dest,
                ManualBooking: manual,
                TravelerInfo: travelers,
                Timeline: timeline,
                Provider: provider
            };
        },
        /**
         * build a url to the hoteldetail page with the given planning data.
         * @param {int} hotelId 
         * @param {int} provider 
         * @param {object} region 
         * @returns {string} 
         */
        getDetailLink: function (hotelId, provider, region) {
            var planningData = {
                DestinationInfo: {
                    VRegion: {
                       RegionName: region.value,
                       RegionID: region.id,
                    } 
                },
                Provider: provider
            };
            var qs = this.serializePlanning(planningData);
            var hotelDetails = '/#/hotel-adestinn-details/' + hotelId + '/' + qs;

            // If the hotel has no region (region.id == 0), 'rn=[region name]&' is 
            // missing, needs to be inserted into url
            if (region.id === 0) {
                var noRegionHotelDetails = hotelDetails.split('?');
                hotelDetails = noRegionHotelDetails[0] + '?rn=&' + noRegionHotelDetails[1];
            }
            return hotelDetails;
        },

        /**
         * Handles Logging endpoint while booking
         */
        getBookingLogs: function(description, info) {
            //put description info in payload rather than URL
            $.post('/api/booking/logbookinginfo/', {
                Description: description,
                Information: info
            });
        }
    };
});

